var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.816,
    height: 90.647,
    viewBox: "0 0 72.816 90.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_3",
    x: 0,
    y: 0,
    width: 72.816,
    height: 72.407,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_3",
    x: 9.136,
    y: 51.817,
    width: 54.552,
    height: 38.83,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_356_21",
    "data-name": "Component 356 \\u2013 21",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Union_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3-2",
    "data-name": "Union 3",
    d: "M21.757,52.234a8.061,8.061,0,0,1-6.052-.378,7.848,7.848,0,0,1-4.185-4.314,7.971,7.971,0,0,1-5.326-2.851,7.72,7.72,0,0,1-1.937-5.647,7.82,7.82,0,0,1-3.6-4.8,7.675,7.675,0,0,1,.676-5.921A7.686,7.686,0,0,1,.136,22.48a7.767,7.767,0,0,1,3.159-5.088A7.679,7.679,0,0,1,4.722,11.6,7.953,7.953,0,0,1,9.774,8.3,7.818,7.818,0,0,1,13.56,3.645a7.649,7.649,0,0,1,7.3-.373l.026-.006A7.572,7.572,0,0,1,27.407,0a8.016,8.016,0,0,1,5.651,2.172,8.062,8.062,0,0,1,6.051.375A7.848,7.848,0,0,1,43.3,6.864a7.979,7.979,0,0,1,5.324,2.852,7.718,7.718,0,0,1,1.937,5.649,7.817,7.817,0,0,1,3.6,4.8,7.666,7.666,0,0,1-.676,5.922,7.679,7.679,0,0,1,1.2,5.842,7.769,7.769,0,0,1-3.159,5.089,7.68,7.68,0,0,1-1.427,5.792,7.944,7.944,0,0,1-5.052,3.3,7.823,7.823,0,0,1-3.785,4.657,7.658,7.658,0,0,1-7.321.364,7.57,7.57,0,0,1-6.527,3.281A8.014,8.014,0,0,1,21.757,52.234Z",
    transform: "translate(9 6)",
    fill: "#f89c1d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 19.578,
    cy: 19.578,
    r: 19.578,
    transform: "translate(7.832 7.773)",
    fill: "#f5f5f8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Subtraction_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3-2",
    "data-name": "Subtraction 3",
    d: "M36.553,20.83h-.375l-8.767-3.091V4.143c.705-.15,1.4-.32,2.066-.507C32.7,2.731,35.143,1.474,36.553,0V20.829Zm-36.171,0H0V0C1.411,1.473,3.857,2.73,7.074,3.636c.656.184,1.35.354,2.062.506v13.6L.382,20.83ZM22.189,15.9h0l-3.913-1.381L14.36,15.9l0-11.005c1.286.1,2.6.158,3.92.158S20.911,5,22.189,4.894v11Z",
    transform: "translate(18.14 57.82)",
    fill: "#f89c1d"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(16 41.531)",
    fill: "#f89c1d",
    stroke: "#f89c1d",
    strokeWidth: 1,
    fontSize: 39,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldBadge);
export default __webpack_public_path__ + "static/media/gold-badge.4cfce5f5963459e22808008455d36ca4.svg";
export { ForwardRef as ReactComponent };